import styled from "@emotion/styled";
import { motion, useAnimation } from "framer-motion";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import usePrefersReducedMotion from "../../hooks/usePrefersReducedMotion";
import theme from "../../theme";

const Wrapper = styled(motion.div)`
  position: relative;
  padding: ${theme.space("m")} 0;

  &:before,
  &:after {
    content: "";
    position: absolute;
    z-index: -1;
    left: 0;
    right: ${({ animateBorder }) => (animateBorder ? "0%" : "100%")};
    background: ${theme.color("primary")};
    height: 2px;
    transition-property: right;
    transition-duration: ${theme.get(
      "animation.staggeredReveal.transition.duration"
    )}s;
    transition-timing-function: ${theme.get(
      "animation.staggeredReveal.transition.ease"
    )}s;
  }

  &:before {
    top: 0;
  }
  &:after {
    bottom: 0;
  }

  > * {
    margin-bottom: ${theme.space("m")};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

function PageHighlight({ title, action, reveal, ...props }) {
  const controls = useAnimation();
  const prefersReducedMotion = usePrefersReducedMotion();

  const [animateBorder, setAnimateBorder] = useState(
    prefersReducedMotion || reveal === undefined
  );

  const staggerContainerVariants = {
    hide: {},
    show: {
      transition: theme.get("animation.staggeredReveal.transition"),
    },
  };

  const staggerVariants = {
    hide: (custom) => ({ opacity: 0, y: custom == "button" ? 40 : 60 }),
    show: { opacity: 1, y: 0 },
  };

  useEffect(() => {
    if (reveal) {
      setAnimateBorder(true);
      controls.start("show");
    }
  }, [reveal, controls, setAnimateBorder]);

  return (
    <Wrapper
      initial={prefersReducedMotion || reveal === undefined ? "show" : "hide"}
      animate={controls}
      variants={staggerContainerVariants}
      animateBorder={animateBorder}
      {...props}
    >
      <motion.div variants={staggerVariants}>{title}</motion.div>
      <motion.div custom={"button"} variants={staggerVariants}>
        {action}
      </motion.div>
    </Wrapper>
  );
}

PageHighlight.propTypes = {
  title: PropTypes.node.isRequired,
  action: PropTypes.node,
  reveal: PropTypes.bool,
};

export default PageHighlight;
